'use client';

import { Fragment, ReactNode } from 'react';
import { MapProvider } from '../../contexts/MapContext';
import { MapLayersProvider } from '../../contexts/MapLayersContext';
import { ExploreProvider } from './context/ExploreContext';

interface IProps {
  children?: ReactNode;
  mockMapProvider?: boolean;
}

export const ExploreClientWrapper = ({ children, mockMapProvider = false }: IProps) => {
  const MapProviderComponent = mockMapProvider ? Fragment : MapProvider;
  return (
    <MapProviderComponent>
      <ExploreProvider>
        <MapLayersProvider>{children}</MapLayersProvider>
      </ExploreProvider>
    </MapProviderComponent>
  );
};
